import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import React, {useState} from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

import { withRouter, Link , useHistory} from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import profile from "../../assets/images/logo-light.png";
import bg from "assets/images/background_image.jpg";
import axios from "axios";
import { COMPANY, POST_PASSWORD_FORGET } from "helpers/url_helper";
import toastr from "toastr";
import { TOAST_OPTIONS, Config } from "helpers/backend_helper";

const ForgetPasswordPage = props => {
  const history = useHistory()
  toastr.options = TOAST_OPTIONS;
  const [isLoading, setIsLoading] = useState(false)
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
      setIsLoading(true)
      axios.post(POST_PASSWORD_FORGET, JSON.stringify(values), Config)
      .then((r)=>{
        if(r.data.status == 1){
          toastr.success( r.data.message);
          history.push("/login")
        }else{
          toastr.error( r.data.message);
        }
        setIsLoading(false)
      })
      .catch((e)=>{
        console.log(e);
        setIsLoading(false)
      });
    }
  });



  return (
    <React.Fragment>
      <MetaTags>
      <title>Forgot Password | {COMPANY}</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
        <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">
                
                
                      <div className="text-primary p-4">
                      <img src={profile} alt="" className="img-fluid" height="40" />
                      </div>

                  
                  <div className="p-2">
              

                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          {isLoading?(<button className="btn btn-warning" type="button">Please wait...</button>):(<button className="btn btn-primary" type="submit">Reset</button>)}
                        </Col>
                      </Row>
                    </Form>
                  </div>
                  <div className="mt-5 text-center">
                <p>
                  Go back to{" "}
                  <Link to="login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <p>
                </p>
              </div>
                </CardBody>
              </Card>
          
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
